import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  id: 'reschedule',
  title: 'Pick a date',
  showActionCta: true,
  actionCtaProps: {
    title: 'Calendar',
    minimumDate: '1690926782000',
    maximumDate: '1691445182000'
  },
  slotListTitle: 'Pick a time slot',
  dataList: [{
    title: '4',
    subtitle: 'fri',
    value: '1691099582000',
    isSelected: false,
    isEmptySlotList: false,
    slotList: [{
      title: '11:00 am – 1:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '12:00 pm – 3:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '3:00 pm – 4:00 pm',
      isSelected: false,
      value: {}
    }]
  }, {
    title: '5',
    subtitle: 'sat',
    value: '1691185982000',
    isSelected: false,
    isEmptySlotList: true,
    slotList: []
  }, {
    title: '6',
    subtitle: 'sun',
    value: '1691272382000',
    isSelected: false,
    isEmptySlotList: false,
    slotList: [{
      title: '11:00 am – 1:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '12:00 pm – 3:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '3:00 pm – 4:00 pm',
      isSelected: false,
      value: {}
    }]
  }, {
    title: '7',
    subtitle: 'mon',
    value: '1691358782000',
    isSelected: false,
    isEmptySlotList: false,
    slotList: [{
      title: '11:00 am – 1:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '12:00 pm – 3:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '3:00 pm – 4:00 pm',
      isSelected: false,
      value: {}
    }]
  }, {
    title: '8',
    subtitle: 'tue',
    value: '1691445182000',
    isSelected: false,
    isEmptySlotList: false,
    slotList: [{
      title: '11:00 am – 1:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '12:00 pm – 3:00 pm',
      isSelected: false,
      value: {}
    }, {
      title: '3:00 pm – 4:00 pm',
      isSelected: false,
      value: {}
    }]
  }],
  callOutWidgetProps: {
    description: 'no slots available on the selected day. try with a different date.',
    iconName: 'InfoIcon',
    state: 'error',
    testID: 'CalloutWidgetContainer'
  },
  onSlotPress: {
    id: 'on slot press',
    actions: [{
      analyticsAction: 'click',
      type: 'nativeEventEmitter',
      replaceValueInPayload: ['payload.eventData.widgetData.selectedDate', 'payload.eventData.widgetData.selectedTimeSlot', 'payload.eventData.widgetData.leftCta'],
      payload: {
        eventName: 'onPress',
        eventData: {
          widgetData: {
            selectedDate: '{{local: selectedDate}}',
            selectedTimeSlot: '{{local: selectedTimeSlot}}',
            leftCta: {
              title: 'CONFIRM',
              buttonType: 'primary',
              version: 'variable-width',
              disabled: false
            }
          }
        }
      }
    }]
  }
}, getTestId('SchedulingWidgetContainer'));